<template>
  <div class="register-wrapper">
    <div class="title-wrapper">视觉训练档案</div>
    <el-form
      :model="registerForm"
      class="register-form-wrapper"
      ref="registerForm"
      :rules="registerFormjRules"
      label-width="5px"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="12" :offset="0">
          <el-form-item prop="fullName">
            <el-input
              v-model="registerForm.fullName"
              placeholder="姓名"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12" :offset="0">
          <el-form-item prop="birth">
            <el-date-picker
              class="date-wrapper"
              value-format="yyyy-MM-dd"
              v-model="registerForm.birth"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker> </el-form-item
        ></el-col>
      </el-row>
      <el-form-item prop="phone">
        <el-input
          v-model="registerForm.phone"
          placeholder="手机号"
          class="phone-input"
        ></el-input>
      </el-form-item>
      <div class="code-wrapper">
        <el-form-item prop="picCode">
          <el-input
            v-model="picCode"
            placeholder="图片验证码"
            class="phone-input"
          ></el-input>
          <div class="pic-code-img" @click="changeSmsPicCode">
            <img :src="picCodeUrl" alt="图片验证码" />
          </div>
        </el-form-item>
      </div>
      <div class="code-wrapper">
        <el-form-item prop="code">
          <el-input
            class="code-input"
            v-model="registerForm.code"
            placeholder="短信验证码"
          ></el-input>
          <el-button class="code-btn" type="primary" @click="handleSmsCode">
            {{
              isAllowedSendSms ? '发送验证码' : `(${currentSecond})秒后重新发送`
            }}</el-button
          >
        </el-form-item>
      </div>
      <div class="sight-wrapper">
        <div class="eye-wrapper-title">裸眼视力</div>
        <div class="eye-wrapper-content">
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item prop="rightSight" label="右眼:" label-width="80px">
                <el-select v-model="registerForm.rightSight" clearable>
                  <el-option
                    v-for="(item, index) in eyeSight"
                    :label="item"
                    :value="item"
                    :key="index"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12" :offset="0">
              <el-form-item prop="leftSight" label="左眼:" label-width="80px">
                <el-select
                  v-model="registerForm.leftSight"
                  clearable
                  class="width300"
                >
                  <el-option
                    v-for="(item, index) in eyeSight"
                    :label="item"
                    :value="item"
                    :key="index"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
          </el-row>
        </div>
      </div>
      <div class="sight-wrapper">
        <div class="eye-wrapper-title">矫正视力(戴镜视力)</div>
        <div class="eye-wrapper-content">
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item
                prop="rightCorrected"
                label="右眼:"
                label-width="80px"
              >
                <el-select v-model="registerForm.rightCorrected" clearable>
                  <el-option
                    v-for="(item, index) in eyeSight"
                    :label="item"
                    :value="item"
                    :key="index"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12" :offset="0">
              <el-form-item
                prop="leftCorrected"
                label="左眼:"
                label-width="80px"
              >
                <el-select v-model="registerForm.leftCorrected" clearable>
                  <el-option
                    v-for="(item, index) in eyeSight"
                    :label="item"
                    :value="item"
                    :key="index"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
          </el-row>
        </div>
      </div>
      <div class="file-create-wrapper">
        <el-button round type="primary" @click="handleSubmit"
          >创建档案</el-button
        >
      </div>
    </el-form>
    <el-dialog :visible.sync="showSuccessDialog" title="注册信息" width="80%">
      <div class="success-wrapper-dialog">
        <span>恭喜你完成了注册!!</span>
        <el-button @click="hideShowSuccessDialog" type="primary"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { eyeSight } from '@src/constant/train'
import { validateForm } from '@utils'
import validateMobile from '@/utils/validator/validateMobile.js'
import {
  smsCode,
  getPicCode,
  registerBySign,
  // picCodeNew,
  // generateQrcode,
  // loop,
  // getContent,
} from '@api/login'
const initRegisterForm = {
  fullName: '',
  age: null,
  phone: '',
  birth: '',
  leftCorrected: '',
  rightCorrected: '',
  rightSight: '',
  leftSight: '',
}
@Component()
// 注意修改class名
export default class Register extends Vue {
  registerForm = {
    ...initRegisterForm,
  }
  picCodeUrl = ''

  showSuccessDialog = false

  exCode = '' // 注册代码,从url中获取

  picCode = ''

  eyeSight = eyeSight

  isAllowedSendSms = true

  currentSecond = 60

  created() {
    this.registerFormjRules = {
      fullName: [
        {
          required: true,
          message: '请输入姓名',
          trigger: ['blur', 'change'],
        },
      ],
      birth: [
        {
          required: true,
          message: '请选择出生日期',
          trigger: ['blur', 'change'],
        },
      ],
      phone: [
        {
          required: true,
          validator: validateMobile,
          trigger: ['blur', 'change'],
        },
      ],
      code: [
        {
          required: true,
          message: '请输入短信验证码',
          trigger: ['blur', 'change'],
        },
      ],
      leftCorrected: [
        {
          required: true,
          message: '不能为空!',
          trigger: ['blur', 'change'],
        },
      ],
      rightCorrected: [
        {
          required: true,
          message: '不能为空!',
          trigger: ['blur', 'change'],
        },
      ],
      leftSight: [
        {
          required: true,
          message: '不能为空!',
          trigger: ['blur', 'change'],
        },
      ],
      rightSight: [
        {
          required: true,
          message: '不能为空!',
          trigger: ['blur', 'change'],
        },
      ],
    }
    this._getSmsPicCode()
    this.exCode = this.$route.query.excode || ''
  }
  handleSmsCode() {
    if (this.isAllowedSendSms) {
      this._sendSmsCode()
    } else {
      this.$message.warning(`下次发送需要${this.currentSecond}秒`)
    }
  }

  // 设置定时器
  initTimeComputed() {
    let timer
    if (!this.isAllowedSendSms) {
      // 不允许发送期,初始化新的计时器
      timer = setInterval(() => {
        this.currentSecond--

        // 初始化重置条件
        if (this.currentSecond === 0) {
          this.isAllowedSendSms = true
          window.clearInterval(timer)
          timer = null
          this.currentSecond = 60
        }
      }, 1000)
    }
  }

  async _sendSmsCode() {
    if (this.registerForm.fullName && this.registerForm.phone && this.picCode) {
      this.isAllowedSendSms = false
      this.initTimeComputed() // 定时器启动
      const res = await smsCode({
        phone: this.registerForm.phone,
        imageCaptcha: this.picCode,
      })
      res.code !== 0
        ? this.$message.warning(res.message)
        : this.$message.success(res.message)
    } else {
      this.$message.warning('姓名、手机号,图片验证码不能为空')
    }
  }

  async _getSmsPicCode() {
    try {
      const data = await getPicCode()
      console.log(data)
      let blob = new Blob([data], { type: 'image/jpg' })
      // const url = URL.createObjectURL(blob)
      // console.log(url)
      var Fr = new FileReader()
      Fr.readAsDataURL(blob)
      Fr.onload = event => {
        this.picCodeUrl = event.target.result
      }
    } catch (error) {
      console.log(error)
    }
  }
  async changeSmsPicCode() {
    await this._getSmsPicCode()
  }

  async _postRegisterForm(params) {
    try {
      const { code } = await registerBySign(params)
      if (code === 0) {
        // 成功注册
        this.$router.push({ path: '/register-result' })
      }
    } catch (err) {
      console.log(err)
    }
  }

  preDealParams(row) {
    const {
      leftCorrected,
      leftSight,
      rightSight,
      rightCorrected,
      code,
      phone,
      fullName,
      birth,
    } = row
    const res = {
      exCode: this.exCode,
      smsCaptcha: code, // 短信验证码
      user: {
        phone,
        fullName,
        birth,
      },
      caseData: {
        leftCorrected,
        rightSight,
        leftSight,
        rightCorrected,
      },
    }
    return res
  }

  hideShowSuccessDialog() {
    this.showSuccessDialog = false
  }

  async handleSubmit() {
    const valid = await validateForm.call(this, 'registerForm')
    if (valid) {
      const params = this.preDealParams(this.registerForm)
      await this._postRegisterForm(params)
    } else {
      this.$message.warning('表单内容有误!')
    }
    console.log(valid)
  }
}
</script>

<style lang="scss" scoped>
.register-wrapper {
  height: 100vh;

  width: 100%;

  background-color: #f8f9f9;

  padding: 30px 20px 20px 20px;

  display: flex;

  flex-direction: column;

  align-items: center;

  .title-wrapper {
    font-size: 2.5rem;

    width: 100%;

    padding: 20px 0 0 20px;

    color: #1582f0;

    background-color: white;

    font-weight: bold;

    text-align: left;
  }

  .register-form-wrapper {
    width: 100%;

    padding: 30px;

    background-color: white;

    .date-wrapper {
      width: 100%;
    }

    .name-wrapper {
      width: 100%;

      display: flex;
    }

    .code-wrapper {
      width: 100%;

      .code-input {
        width: calc(100% - 160px);
      }

      .phone-input {
        width: calc(100% - 80px);
      }

      .pic-code-img {
        width: 75px;

        margin-left: 5px;

        display: inline-block;

        // background-color: red;

        img {
          width: 100%;

          height: 100%;
        }
      }

      .code-btn {
        margin-left: 15px;

        width: 145px;
      }
    }

    .sight-wrapper {
      .eye-wrapper-title {
        margin: 10px 0;
      }
    }

    .file-create-wrapper {
      display: flex;

      justify-content: center;
    }
  }
}

.success-wrapper-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  span {
    margin: 30px;
    font-size: 20px;
  }
}
</style>
